import { Component,ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {IUserDetails} from '../../models/user.model';
import {UserService} from '../../services/user.service';
import { ConfirmPasswordValidator } from "../../../shared/validators";
import {LocalStorageService} from 'ngx-webstorage';
@Component({
  selector: 'app-vendor-register-profile1',
  templateUrl: './vendor-register-profile1.component.html',
  styleUrls: ['./vendor-register-profile1.component.scss']
})
export class VendorRegisterProfile1Component implements OnInit {
  preregisterForm: FormGroup;
  myForm:FormGroup;
  loading = false;
  submitted = false;
  currentUser;
  RoleArray: any = ['Super Admin','Admin','Employee'];
  activeRoute: any;
  constructor(
    private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private storage: LocalStorageService
  ) {  this.currentUser = this.storage.retrieve('currentuser'); }

  ngOnInit(): void {
    this.reactiveForm();  
  }

  reactiveForm() {
    this.preregisterForm = this.formBuilder.group({
      // userName: ['', [Validators.required, Validators.email]],
      // firstName: ['', Validators.required],
      // lastName: ['', Validators.required],
      // contactEmail: ['', [Validators.required, Validators.email]],
      // password: ['', [Validators.required, Validators.minLength(8)]],
      // confirmPassword: ['',Validators.required],
      // role: ['',[Validators.required]],
      // companyName: ['', Validators.required],
      // companyEmail: ['', [Validators.required, Validators.email]],
      // companyPhone: ['', Validators.required],
      // city:[''],
      // state:[''],
      // zipCode:[''],
      // onshoreFields: this.formBuilder.array([]) ,
      // referenceFields: this.formBuilder.array([]),
     
  });
  }


}
